import { isReservedSystemRoleSlug } from "../../../public/utils/roleAccess";

export function roleNameById(roles, roleId) {
  if (roleId == null || roleId === "") return "—";
  const id = Number(roleId);
  const r = (roles || []).find((x) => Number(x.id) === id);
  if (!r) return `— (${roleId})`;
  const inactive = Number(r.is_active) === 2 ? " (inactive)" : "";
  return `${r.role_name ?? `— (${roleId})`}${inactive}`;
}

export function filterUserBuilderRoles(roles) {
  return (roles || []).filter(
    (role) =>
      !isReservedSystemRoleSlug(role?.role_slug) &&
      Number(role?.is_active ?? 1) === 1,
  );
}

export function statusNameById(statuses, statusId) {
  if (statusId == null || statusId === "") return "—";
  const id = Number(statusId);
  const s = (statuses || []).find((x) => Number(x.id) === id);
  return s?.status_name ?? `— (${statusId})`;
}

/** ISO / date strings → short local date for tables */
export function formatDateDisplay(val) {
  if (val == null || val === "") return "—";
  try {
    const d = new Date(val);
    if (Number.isNaN(d.getTime())) {
      const s = String(val);
      return s.length >= 10 ? s.slice(0, 10) : s;
    }
    return d.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  } catch {
    return String(val);
  }
}

export function resolveUserStatusId(statuses, mode) {
  if (!statuses?.length) return null;
  const low = (s) => (s.status_name || "").toLowerCase();
  if (mode === "active") {
    const hit = statuses.find(
      (s) => low(s).includes("active") && !low(s).includes("inact")
    );
    return hit?.id ?? statuses[0].id;
  }
  const hit = statuses.find(
    (s) => low(s).includes("inact") || low(s).includes("disable")
  );
  return hit?.id ?? statuses[statuses.length - 1]?.id ?? statuses[0].id;
}

export function formatTimeShort(val) {
  if (val == null || val === "") return "";
  return String(val).slice(0, 5);
}

export function formatShiftOptionLabel(shift) {
  if (!shift) return "";
  const name = String(shift.shift_name ?? "Shift").trim();
  const start = formatTimeShort(shift.start_time);
  const end = formatTimeShort(shift.end_time);
  if (start && end) return `${name} (${start}–${end})`;
  return name;
}

export function formatShiftCell(userRow) {
  if (!userRow?.shift_name && userRow?.attendance_shift_id == null) return "—";
  const name = userRow.shift_name || "Shift";
  const start = formatTimeShort(userRow.shift_start_time);
  const end = formatTimeShort(userRow.shift_end_time);
  if (start && end) return `${name} (${start}–${end})`;
  return name;
}

export function formatLocationCell(userRow) {
  const label = userRow?.location_label;
  if (label == null || String(label).trim() === "") return "—";
  return String(label);
}
